import React from 'react';
import styled from '@emotion/styled';
import { Skeleton, SkeletonWrapper } from '../../atoms/skeleton';

const DetailsSkeletonWrapper = styled(SkeletonWrapper)`
  grid-area: product-information;
`;

const CarouselSkeletonWrapper = styled(SkeletonWrapper)`
display: flex;
  grid-area: product-carousel;

  ${Skeleton}::before {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`;

const BreadcrumbSkeletonWrapper = styled(SkeletonWrapper)`
  grid-area: breadcrumbs;

  ${Skeleton} {
    height: 1.5rem;
    margin-bottom: 3rem;
  }
`;

const DetailsSkeleton = () => (
  <DetailsSkeletonWrapper>
    {/* Product Header */}
    <Skeleton css={{ height: '12rem', marginBottom: '3rem' }} />

    {/* Product Information */}
    <Skeleton css={{ height: '35rem', marginBottom: '3rem' }} />

    {/* Product Options */}
    <Skeleton css={{ height: '30rem', marginBottom: '3rem' }} />

    {/* Product Options */}
    <Skeleton css={{ height: '7rem', marginBottom: '3rem' }} />
  </DetailsSkeletonWrapper>
);

const CarouselSkeleton = () => (
  <CarouselSkeletonWrapper>
    <Skeleton />
  </CarouselSkeletonWrapper>
);

const BreadcrumbSkeleton = () => (
  <BreadcrumbSkeletonWrapper>
    <Skeleton />
  </BreadcrumbSkeletonWrapper>
);

const Product = styled.div`
  display: grid;
  grid-gap: 3rem;
  grid-template-areas: 'breadcrumbs' 'product-carousel' 'product-information';
  grid-template-columns: minmax(0, 1fr);
  margin-bottom: 3rem;

  @media (min-width: ${(props) => props.theme.breakpoint.medium}) {
    grid-gap: 5rem;
    grid-template-columns: 50%;
    grid-template-areas: 'breadcrumbs breadcrumbs' 'product-carousel product-information';
  }
`;

const ProductDetailsSkeleton = () => (
  <Product>
    <BreadcrumbSkeleton />
    <CarouselSkeleton />
    <DetailsSkeleton />
  </Product>
);

export default ProductDetailsSkeleton;
